module.exports = new Promise(resolve => {
            const url = "https://mf-onboarding.bprcasa.com/remoteEntry.js?t=" + Date.now();
            const script = document.createElement("script");
            script.src = url;

            script.onload = () => {
              const proxy = {
                get: (request) => window.enrolamiento.get(request),
                init: (arg) => {
                  try {
                    return window.enrolamiento.init(arg);
                  } catch (e) {}
                }
              };
              resolve(proxy);
            };

            document.head.appendChild(script);
          });